<template>
  <form @submit.prevent="search" class="search-input-form clear-fix">
    <div class="tracking-number-container float-left">
      <md-field>
        <label>Tracking Number</label>
        <md-input v-model="trackingNumberLocal" placeholder="Tracking Number"></md-input>
      </md-field>
    </div>
    <div class="countries-container float-left">
      <CountriesDropdown v-model="countryLocal" @change="onCountryCodeChange"></CountriesDropdown>
    </div>
    <div class="search-container float-left">
      <md-button type="submit" class="search-button md-icon-button md-raised md-primary">
        <md-icon>search</md-icon>
      </md-button>
    </div>
  </form>
</template>

<script>
import CountriesDropdown from '@/components/CountriesDropdown'
import { mapActions } from 'vuex'

export default {
  name: 'SearchInput',
  components: {
    CountriesDropdown
  },
  props: {
    trackingNumber: {
      type: String,
      required: false,
      default: null
    },
    country: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      trackingNumberLocal: this.trackingNumber,
      countryLocal: this.country
    }
  },
  methods: {
    ...mapActions('location', [
      'setCountry'
    ]),
    search () {
      this.$emit('search', { trackingNumber: this.trackingNumberLocal, country: this.countryLocal })
    },
    onCountryCodeChange (countryCode) {
      this.setCountry({ countryCode })
    }
  },
  mounted () {
    this.countryLocal = this.country.toUpperCase()
  }
}
</script>

<style lang="sass" scoped>
.search-input-form
  width: 100%
  height: 100%

  .tracking-number-container
    width: 60%
    @media (max-width: $small-device-width)
      width: 100%

  .countries-container
    margin-left: 15px
    width: calc(25% - 15px)
    @media (max-width: $small-device-width)
      margin: -20px 0 0 0
      width: 70%

  .search-container
    margin-top: 15px
    margin-left: 15px
    width: calc(15% - 15px)
    @media (max-width: $small-device-width)
      margin: 0 0 0 15px
      width: calc(30% - 15px)
</style>
